import * as React from "react";
const SvgFiBrandsPhp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M1.978 8.507h3.707q1.633.014 2.367.903.733.89.484 2.43a4.5 4.5 0 0 1-.429 1.381 4.1 4.1 0 0 1-.885 1.222q-.692.69-1.48.877a7 7 0 0 1-1.633.186H2.45l-.526 2.524H0zm1.619 1.514-.83 3.984q.082.014.165.013h.194q1.328.014 2.214-.252.884-.279 1.19-1.939.248-1.395-.499-1.607-.732-.213-1.84-.199-.165.014-.317.013h-.29zM10.726 5.97h1.91l-.54 2.537h1.716q1.41.027 2.103.558.705.53.414 2.02l-.927 4.422h-1.936l.885-4.223q.139-.664-.083-.943t-.955-.279l-1.535-.013-1.134 5.458h-1.91zM18.38 8.507h3.706q1.633.014 2.366.903.732.89.484 2.43a4.5 4.5 0 0 1-.429 1.381 4.1 4.1 0 0 1-.885 1.222q-.692.69-1.48.877a7 7 0 0 1-1.633.186h-1.66l-.526 2.523H16.4zm1.618 1.514-.83 3.984q.082.014.165.013h.194q1.328.014 2.214-.252.884-.279 1.19-1.939.248-1.395-.499-1.607-.733-.213-1.84-.199-.165.014-.317.013h-.29z"
    />
  </svg>
);
export default SvgFiBrandsPhp;
